<template>
  <div class="page">

    <!-- 顶部栏 -->
    <header class="topbar">
      <div class="tb-back" @click="$router.back()">
        <i class="fa-solid fa-chevron-left"></i>
      </div>
      <h1 class="tb-title">更多优惠</h1>
      <div class="tb-spacer"></div>
    </header>

    <!-- 筛选栏 -->
    <div class="filter-bar">
      <div
        v-for="f in filters"
        :key="f.key"
        class="filter-tag"
        :class="{ active: activeFilter === f.key }"
        @click="activeFilter = f.key"
      >
        {{ f.label }}
      </div>
    </div>

    <!-- 商品列表 -->
    <div class="product-list">
      <router-link
        v-for="item in filteredProducts"
        :key="item.id"
        :to="`/product/${item.id}`"
        class="product-row"
      >
        <div class="pr-img">
          <img
            :src="item.image ? imgUrl(item.image) : '/no_pic.png'"
            :alt="item.name"
          />
          <span v-if="item.tag" class="pr-tag" :class="getTagClass(item.tag)">{{ item.tag }}</span>
        </div>
        <div class="pr-info">
          <h4 class="pr-name">{{ item.name }}</h4>
          <p class="pr-desc">{{ item.description || '优质商品，值得信赖' }}</p>
          <div class="pr-bottom">
            <div class="pr-price">
              <span class="pr-label">补贴价</span>
              <span class="pr-now">¥{{ item.subsidy_price || item.avg_price }}</span>
              <span v-if="item.original_price" class="pr-orig"><s>¥{{ item.original_price }}</s></span>
            </div>
            <span class="pr-sale">已售{{ item.view_count || 0 }}件</span>
          </div>
        </div>
      </router-link>

      <!-- 空状态 -->
      <div v-if="filteredProducts.length === 0 && !loading" class="empty">
        <i class="fa-solid fa-box-open"></i>
        <p>暂无更多优惠</p>
      </div>

      <!-- 加载中 -->
      <div v-if="loading" class="loading">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <span>加载中...</span>
      </div>

      <div v-if="!loading && noMore && products.length > 0" class="no-more">
        — 没有更多了 —
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MoreProducts',

  data() {
    return {
      products: [],
      loading: false,
      noMore: false,
      page: 1,
      pageSize: 10,
      activeFilter: 'all',
      filters: [
        { key: 'all', label: '吴川市' },
        { key: 'subsidy', label: '补贴商品' },
        { key: 'new', label: '新品上架' },
        // { key: 'hot', label: '热销商品' }
      ]
    }
  },

  computed: {
    townId() {
      return this.$route.query.townId || '0'
    },
    filteredProducts() {
      if (this.activeFilter === 'all') return this.products
      if (this.activeFilter === 'subsidy') return this.products.filter(p => p.tag === '补贴')
      if (this.activeFilter === 'new') return this.products.filter(p => p.tag === '上新')
      if (this.activeFilter === 'hot') return this.products.filter(p => p.tag === '热销')
      return this.products
    }
  },

  mounted() {
    this.fetchProducts(true)
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    async fetchProducts(reset = false) {
      if (this.loading) return
      if (reset) {
        this.page = 1
        this.noMore = false
        this.products = []
      }
      if (this.noMore) return

      this.loading = true
      try {
        let url = `/api/v1/products/search?page=${this.page}&pageSize=${this.pageSize}`
        if (this.townId && this.townId !== '0') {
          url += `&townId=${this.townId}`
        }
        const res = await this.$api.get(url)
        const list = res.data.data?.list || []

        if (reset) {
          this.products = list
        } else {
          this.products.push(...list)
        }

        if (list.length < this.pageSize) {
          this.noMore = true
        } else {
          this.page++
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    imgUrl(path) {
      if (!path) return ''
      if (path.startsWith('http')) return path
      const base = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000'
      return base + (path.startsWith('/') ? path : '/' + path)
    },

    goodsIcon(name) {
      if (/电扇|风扇/.test(name)) return 'fa-solid fa-fan'
      if (/月饼/.test(name)) return 'fa-solid fa-gift'
      if (/饭煲|电饭/.test(name)) return 'fa-solid fa-kitchen-set'
      if (/炸锅/.test(name)) return 'fa-solid fa-bowl-rice'
      if (/手机/.test(name)) return 'fa-solid fa-mobile-screen'
      if (/电视/.test(name)) return 'fa-solid fa-tv'
      return 'fa-solid fa-box-open'
    },

    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      const clientHeight = document.documentElement.clientHeight || window.innerHeight

      if (scrollTop + clientHeight >= scrollHeight - 100) {
        this.fetchProducts(false)
      }
    },

    getTagClass(tag) {
      if (!tag) return 'tag-hot'
      if (/新品|上新/.test(tag)) return 'tag-new'
      if (/热销|火爆/.test(tag)) return 'tag-hot'
      if (/补贴/.test(tag)) return 'tag-subsidy'
      if (/限时|特惠/.test(tag)) return 'tag-limited'
      return 'tag-hot'
    }
  }
}
</script>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');

*, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

.page {
  width: 100%;
  min-height: 100vh;
  background: #f4f8fb;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: #1f2937;
  padding-top: 48px;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

/* ================================================================
   顶部栏
   ================================================================ */
.topbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 12px;
  background: #fff;
  border-bottom: 1px solid #f3f4f6;
}

.tb-back {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  color: #1f2937;
}

.tb-back:active { background: #f3f4f6; }
.tb-back i { font-size: 14px; }

.tb-title {
  flex: 1;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
}

.tb-spacer { width: 32px; }

/* ================================================================
   筛选栏
   ================================================================ */
.filter-bar {
  position: sticky;
  top: 48px;
  z-index: 99;
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  background: #f4f8fb;
}

.filter-bar::-webkit-scrollbar { display: none; }

.filter-tag {
  flex-shrink: 0;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  background: #fff;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all .2s;
}

.filter-tag.active {
  background: #0167CC;
  color: #fff;
  border-color: #0167CC;
}

.filter-tag:active { transform: scale(.95); }

/* ================================================================
   商品列表
   ================================================================ */
.product-list {
  padding: 0 12px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.product-row {
  display: flex;
  gap: 12px;
  background: #fff;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,.04);
  transition: transform .2s;
  text-decoration: none;
  color: inherit;
}

.product-row:active { transform: scale(.99); }

.pr-img {
  width: 90px;
  height: 90px;
  min-width: 90px;
  border-radius: 10px;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.pr-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pr-img i {
  font-size: 28px;
  color: #d1d5db;
}

.pr-tag {
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 8px 0 8px 0;
  font-weight: 500;
}

/* 热销标签 - 红色 */
.tag-hot {
  background: #ef4444;
}

/* 新品标签 - 绿色 */
.tag-new {
  background: #22c55e;
}

/* 补贴标签 - 橙色 */
.tag-subsidy {
  background: #f97316;
}

/* 限时标签 - 紫色 */
.tag-limited {
  background: #a855f7;
}

.pr-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
}

.pr-name {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pr-desc {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pr-bottom {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 4px;
}

.pr-price {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.pr-label {
  font-size: 10px;
  color: #ef4444;
}

.pr-now {
  font-size: 18px;
  font-weight: 800;
  color: #ef4444;
}

.pr-orig {
  font-size: 10px;
  color: #9ca3af;
}

.pr-sale {
  font-size: 10px;
  color: #9ca3af;
  flex-shrink: 0;
}

/* ================================================================
   空状态 / 加载
   ================================================================ */
.empty, .loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #9ca3af;
}

.empty i, .loading i {
  font-size: 36px;
  margin-bottom: 12px;
  opacity: .5;
}

.empty p, .loading span {
  font-size: 14px;
}

.no-more {
  text-align: center;
  padding: 16px 0;
  font-size: 12px;
  color: #d1d5db;
}

/* ================================================================
   响应式
   ================================================================ */
@media (max-width: 360px) {
  .pr-img { width: 76px; height: 76px; min-width: 76px; }
  .pr-now { font-size: 16px; }
}

@media (min-width: 481px) {
  .product-list { padding: 0 16px 24px; }
  .pr-img { width: 100px; height: 100px; min-width: 100px; }
  .pr-name { font-size: 15px; }
  .pr-now { font-size: 20px; }
}
</style>
